module.exports = __webpack_public_path__ + "static/team-6e4ab1ad11201bf30a57f63c1ee133ae.jpg";